<script setup>
import alertLabels from '@/config/labels/alertLabels.js';
import poboxLabels from '@/config/labels/poboxLabels.js';
import agencyLabels from '@/config/labels/agencyLabels.js';
import packageLabels from '@/config/labels/packageLabels.js';
import warehouseLabels from '@/config/labels/warehouseLabels.js';
import statusWarehouseLabels from '@/config/labels/statusWarehouseLabels.js';
import guideLabels from '@/config/labels/guideLabels.js';
import statusGuideLabels from '@/config/labels/statusGuideLabels.js';
import invoiceLabels from '@/config/labels/invoiceLabels.js';
import paymentLabels from '@/config/labels/paymentLabels.js';
import quoteLabels from '@/config/labels/quoteLabels.js';
import pickupLabels from '../../config/labels/pickupLabels';
import packageStatusLabels from '@/config/labels/packageStatusLabels.js';
import poBoxDashboard from '@/config/labels/poBoxDashboard.js';

const props = defineProps({
    bodyType: String,
    onInsertPlaceholder: Function
});

const labelsMap = {
    Alert: alertLabels,
    Pobox: poboxLabels,
    PoBoxDashboard: poBoxDashboard,
    Agency: agencyLabels,
    Receipt: packageLabels,
    WHrec: warehouseLabels,
    Statuswhrec: statusWarehouseLabels,
    Guide: guideLabels,
    Statusguide: statusGuideLabels,
    Bill: invoiceLabels,
    Billpay: paymentLabels,
    Quote: quoteLabels,
    Pickup: pickupLabels,
    Listpackages: packageStatusLabels
};

const currentLabels = labelsMap[props.bodyType] || [];

const handleClick = (placeholder) => {
    if (props.onInsertPlaceholder) {
        props.onInsertPlaceholder(placeholder);
    }
};
</script>

<template>
    <v-row>
        <v-col
            v-for="(section, sIndex) in currentLabels"
            :key="sIndex"
            cols="12"
        >
            <h3 class="mb-3 text-primary">{{ section.title }}</h3>

            <v-row>
                <v-col
                    cols="12"
                    md="6"
                    v-for="(field, fIndex) in section.fields"
                    :key="fIndex"
                >
                    <div
                        class="p-3 label-clickable"
                        v-if="field.visible"
                        @mousedown.prevent="handleClick(field.label)"
                    >
                        <p>
                            <strong>{{ field.label }}</strong> -
                            {{ $t(field.description) }}
                        </p>
                    </div>
                </v-col>
            </v-row>

            <v-divider class="mt-3"></v-divider>
        </v-col>
    </v-row>
</template>

<style scoped>
.label-clickable {
    cursor: pointer;
    transition: background 0.2s;
}
.label-clickable:hover {
    background: #f0f0f0;
}
</style>
